import { createSelector } from "reselect";

const mailSelector = state => state.mail;

export const messagesSelector = createSelector(mailSelector, (mail) => mail.messages || []);
export const hasMoreSelector = createSelector(mailSelector, (mail) => mail.hasMore );
export const currentMessageSelector = createSelector(mailSelector, (mail) => mail.currentMessage.message );
export const actionMessageSelector = createSelector(mailSelector, (mail) => mail.currentMessage );
export const isUnreadMessages = createSelector(mailSelector, (mail) => mail.unread);
